import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import store from '../../store';
import {
    required,maxLength
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "gradingCreate",
    components: {
        MainLayout,
        Select2Multiple,
        flatPickr,
        Loading
    },

    data() {
        return {
            isLoading: false,
            classData: {},
            selectedClass: 0,
            classArr: [],
            subjectArr: [],
            studentNameArr: [],
            examNameArr: [],
            academic_year: '',
            academicYear: '',
            class_id: '',
            remark: '',
            gradingSelected: 0,
            exam_id: '',
            student_id: 0,
            subject_id: '',
            academicYearArr: null,
            gradingArr: null,
            submitted: false,
            autoGrading: false,
            marks: [],
            grades: [],
            comment: [],
            mark_ErrMsg: [],
            grade_ErrMsg: [],
            subject_ErrMsg: '',
            comment_msg: [],
            msgCount: 0,
            id: 0,
            cmt: 0,
            cmtCount: 0,
            isError: false,
            noStudentMsg:'',
            noExamMsg: '',
            VALID_GRADES: '',
            gradingBy: 'student',
            duplicateErrors: {},
        };
    },

    validations: {
        class_id: {
            required
        },
        academic_year: {
            required
        },
        student_id: {
            required
        },
        subject_id: {
            required
        },
        exam_id: {
            required
        },
        comment: {
            $each: {
                maxLength: maxLength(1000)
            }
        }
    },

    methods: {
      getCurrentPeriodList() {
        axios.get('/period/getCurrentPeriodList', {
          params: {
            campus_id: store.state.user.campus_id,
          }
        })
          .then(res => {
            let $defaultSelectOption = [{
              'id': 0,
              'text': 'Select Academic Year'
            }];
            this.academicYearArr = $defaultSelectOption.concat(res.data);
            this.isLoading = false;
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            this.isLoading = false;
          });
      },
        
        changeEvent(val, fieldName) {
            this.submitted = false;
            this.$set(this, fieldName, val);
            switch (fieldName) {
                case "academic_year":
                   this.isLoading = true;                 
                   this.classArr = [];
                   this.subjectArr = [];
                   this.studentNameArr = [];
                   this.mark_ErrMsg= [];
                   this.grade_ErrMsg= [];
                   this.examNameArr = [];
                   this.subject_ErrMsg= '';
                   this.marks = [];
                   this.grades = [];
                   this.comment = [];
                   this.comment_msg= [];
                   this.subject_id = -1;
                   this.student_id = 0;
                   this.class_id = 0;
                   this.exam_id = '';
                   this.selectedClass = 0;
                    this.getClass(val);
                    break;
                
                case "class_id": 
                   this.isLoading = true;
                   this.subjectArr = [];
                   this.studentNameArr = [];
                   this.mark_ErrMsg= [];
                   this.grade_ErrMsg= [];
                   this.examNameArr = [];
                   this.subject_ErrMsg = '';
                   this.marks = [];
                   this.grades = [];
                   this.exam_id = '',
                   this.comment = [];
                   this.comment_msg = [];
                   this.subject_id = -1;
                   this.student_id = 0;
                   this.getStudentName(val);
                   this.getExamforClass(val);
                    break;

                case 'student_id':
                    this.marks = [];
                    this.grades = [];
                    this.comment = [];
                    this.comment_msg = [];
                    break;

                case 'exam_id':
                  this.subject_id = '';
                  this.handleExamChange(val);
                  break;

                case 'subject_id':
                  this.resetData();
                break;
            }
        },

        getClass(academic_year) {
            axios.get("class/classList/" + academic_year, {
                params: {
                    campus_id: store.state.user.campus_id
                }
            })
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class',
                        'subjects': [],
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        changeEventSubject(val, index) {
            let fieldName = val.target.name;
            let errMsg = (fieldName == 'mark') ? this.mark_ErrMsg : this.grade_ErrMsg;
            if (val === null || val === '') {
                errMsg[index] = 'Please Enter Student ' + fieldName;
            } else {
                errMsg[index] = '';
            }
        },
        
        getExamforClass(class_id) {
          axios.get("exam/examList", {
            params: {
              class_id: class_id,
              campus_id: store.state.user.campus_id
            }
          })
            .then(res => {
              if (res.data.length > 0) {
                let $defaultSelectOption = [{
                  'id': 0,
                  'text': 'Select Exam'
                }];
                this.examNameArr = $defaultSelectOption.concat(res.data);
                this.noExamMsg = '';
                this.isLoading = false;
              } else {
                this.examNameArr = [];
                this.noExamMsg = 'No Exam for this class.'
                this.isLoading = false;
              }
            }).catch((error) => {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            });
        },

        getStudentName($classId) {
            axios.get("student/getStudentName/" + $classId, {
                    params: {
                    campus_id: store.state.user.campus_id
                    }
                 })
                 .then(res => {
                  if (res.data.length > 0) {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Student Name'
                    }];
                    this.studentNameArr = $defaultSelectOption.concat(res.data);
                    this.noStudentMsg = '';
                    this.isLoading = false;
                  } else {
                    this.studentNameArr = [];
                    this.noStudentMsg = 'No student for this class.'
                    this.isLoading = false;
                  }
                }).catch((error) => {
                    if (error.response.status == 401) {
                       this.$store.commit('logout');
                       window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getSubjectByClassId($classId) {
            axios
                .get("/class/subjectByClassId/" + $classId, {
                    params: {
                        campus_id: store.state.user.campus_id,
                        acd_year_id: this.academic_year
                    }
                })
                .then((response) => {
                    if (response.data && response.data.subjectArr.length > 0) {
                        this.subjectArr = response.data.subjectArr[0];
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.log("Subject API Error", error);
                });
        },

        async getValidGrades() {
            try {
              const response = await axios.get('grading/valid-grades');
              if (response) {
                this.VALID_GRADES = response.data;  
              }
            } catch (error) {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            }
        },

        confirmRegister() {
          this.msgCount = 0; 
          this.cmtCount = 0;
          this.submitted = true;
          this.isLoading = true;
          this.gradingRows.forEach((item, index) => {
            this.$set(this.mark_ErrMsg, index, '');
            this.$set(this.grade_ErrMsg, index, '');
            this.$set(this.comment_msg, index, '');
          });
          const hasAnyInput = this.gradingRows.some((item, index) => {
            const hasMark = this.marks[index] !== undefined && this.marks[index] !== '' && this.marks[index] !== null;
            const hasGrade = this.grades[index] && this.grades[index].toString().trim() !== '';
            return hasMark || hasGrade;
          });

          if (!hasAnyInput) {
            this.isLoading = false;
            this.$notification.error("Please fill at least one mark or grade.");
            return;
          }
          this.gradingRows.forEach((item, index) => {
            let currentMark = this.marks[index];
            let hasMark = (currentMark !== undefined && currentMark !== '' && currentMark !== null);

            let currentGrade = this.grades[index] ? this.grades[index].toString().trim() : '';
            let hasGrade = (currentGrade !== '');

            if (hasMark || hasGrade) {
              if (hasMark && (currentMark < 0 || currentMark > 100)) {
                this.$set(this.mark_ErrMsg, index, "Mark must be between 0 and 100");
                this.msgCount++;
              }

              if (hasGrade) {
                if (currentGrade.length > 10) {
                  this.$set(this.grade_ErrMsg, index, "Grade must be at most 10 characters.");
                  this.msgCount++;
                } else if (!this.autoGrading && this.VALID_GRADES && !this.VALID_GRADES.includes(currentGrade)) {
                  this.$set(this.grade_ErrMsg, index, `Grade "${currentGrade}" is not valid.`);
                  this.msgCount++;
                }
              }

              let commentLength = this.comment[index] ? this.comment[index].length : 0;
              if (commentLength > 1000) {
                this.$set(this.comment_msg, index, 'Grading comment cannot exceed 1000 characters');
                this.cmtCount++;
              }
            }
          });
          if (this.msgCount > 0 || this.cmtCount > 0) {
              this.isLoading = false;
              return;
          }
          this.Loading = true;
          this.register();
        },

      register() {
        this.duplicateErrors = {};
        const filteredGradingData = this.gradingRows
        .map((item, index) => {
            return {
                student_id: this.gradingBy === 'subject' ? parseInt(item.id) : parseInt(this.student_id),
                subject_id: this.gradingBy === 'student' ? parseInt(item.id) : parseInt(this.subject_id),
                mark: this.marks[index],
                grade: this.grades[index],
                comment: this.comment[index]
            };
        })
        .filter(row => {
            const hasMark = row.mark !== '' && row.mark !== null && row.mark !== undefined;
            const hasGrade = row.grade !== '' && row.grade !== null && row.grade !== undefined;
            return hasMark || hasGrade;
        });
        const request = {
          academic_year: parseInt(this.academic_year),
          class_id: parseInt(this.class_id),
          exam_id: parseInt(this.exam_id),
          autoGrading: this.autoGrading ? 1 : 0,
          gradingBy: this.gradingBy,
          student_id: this.student_id ? parseInt(this.student_id) : null,
          subject_id: this.subject_id ? parseInt(this.subject_id) : null,
          grading_data: filteredGradingData
        };

        axios.post("/grading/create", request, {
          headers: {
            'Content-Type': 'application/json',
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            this.isLoading = false;
            this.$notification.success("Grading Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "gradingList"
            });
          }
          else if (response.data.success == false) {
            this.isLoading = false;
            this.$notification.error(response.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          } else {
            this.isLoading = false;
            this.$notification.error("Something went wrong", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch(error => {
          this.isLoading = false;
          if (error.response?.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
            return;
          }
          if (error.response?.status === 409) {
            const data = error.response.data || {};
            const message = data.message || "Grading record already exists.";
            if (data.duplicate_id) {
              this.$set(this.duplicateErrors, data.duplicate_id, message);
            }
            this.$notification.error(message, {
              timer: 3,
              position: "bottomCenter"
            });
            return;
          }
          if (error.response?.status === 422) {
            const errors = error.response.data.errors;
            const firstError = errors
              ? Object.values(errors)[0][0]
              : error.response.data.message;
            this.$notification.error(firstError || "Grading create failed", {
              timer: 3,
              position: "bottomCenter"
            });
            return;
          }
          this.$notification.error(
            error.response?.data?.message || "Grading create failed",
            {
              timer: 3,
              position: "bottomCenter"
            }
          );
          console.log("Grading Create API Error", error.response?.data || error);
        });
      },

      showList() {
        this.$router.push({
          path: "/grading/list"
        });
      },

      handleExamChange(val) {
        if (!val || val == 0) {
          this.subjectArr = [];
          return;
        }
        const selectedExam = this.examNameArr.find(e => e.id == val);
        if (selectedExam && selectedExam.subjects) {
          this.subjectArr = selectedExam.subjects.map(s => ({
            id: s.id,
            text: s.subject_name
          }));
        }
        this.isLoading = false;
      },

      resetData() {
        this.marks = [];
        this.grades = [];
        this.comment = [];
        this.mark_ErrMsg = [];
        this.grade_ErrMsg = [];
        this.comment_msg = [];
        this.subject_ErrMsg = '';
      },
    },

    computed: {
      gradingRows() {
        if (!this.gradingBy) return [];

        if (this.gradingBy === 'student') {
          return (this.student_id != 0 && this.student_id != null) ? this.subjectArr : [];
        } else {
          return (this.subject_id != '' && this.subject_id != -1) ?
            this.studentNameArr.filter(s => s.id != 0) : [];
        }
      }
    },

    mounted() {
        this.isLoading = true;
        this.getCurrentPeriodList();
        this.getValidGrades();
    },
};
